import FolderInterface from "./FolderInterface";
import Client from '../Client/Client';
import Receipt from '../Receipt/Receipt';
import InvalidElement from "./InvalidElementInterface";

class Folder implements FolderInterface {
  id: string
  form_id: string
  client_id: number|null
  advisor_id: number
  last_submitted_block_id: string|null
  values: Array<string>
  direct: boolean
  receipts: Receipt[]|null
  authorizedClients: number[]
  status: Array<string>|undefined
  errors: InvalidElement[]|null|undefined
  unableToCorrect?: boolean | null

  constructor(
    id: string,
    form_id: string,
    client_id: number|null,
    advisor_id: number,
    last_submitted_block_id: string|null,
    values: Array<string>,
    direct: boolean,
    receipts: Receipt[]|null,
    authorizedClients: number[],
    status?: Array<string>,
    errors?: InvalidElement[]|null,
    unableToCorrect?: boolean | null
  ) {
    this.id = id
    this.form_id = form_id
    this.client_id = client_id
    this.advisor_id = advisor_id
    this.last_submitted_block_id = last_submitted_block_id
    this.values = values
    this.direct = direct
    this.receipts = receipts
    this.authorizedClients = authorizedClients
    this.status = status
    this.errors = errors
    this.unableToCorrect = unableToCorrect
  }
}

class FolderDetail implements FolderInterface{
  id: string
  creation_date: Date
  validation_data: Date
  signature_date: Date
  status: string
  client: Client
  detail: Array<string>
  advisor: { external_id: string, name: string, firstname?: string }
  present: string
  subscriptionGlobalAmount: string
  integrate_state: string
  formId: string
  detention_mode: string|null
  dismemberment_type: string|null
  dismemberment_scope: string|null
  pairing: {[scope: string]: string|null}|null
  plateforme_state: string
  nb_parts: number|string
  is_physical: boolean|null
  product_name?: string
  nature?: string
  manager?: { external_id: string, name: string, firstname?: string }

  constructor(
    id: string,
    creation_date: Date,
    validation_date: Date,
    signature_date: Date,
    status: string,
    client: Client,
    detail: Array<string>,
    advisor: { external_id: string, name: string, firstname?: string },
    present: string,
    subscriptionGlobalAmount: string,
    integrate_state: string,
    formId: string,
    detention_mode: string|null,
    dismemberment_type: string|null,
    dismemberment_scope: string|null,
    pairing: {[scope: string]: string|null}|null = null,
    plateforme_state: string,
    nb_parts: number|string,
    is_physical: boolean|null,
    product_name?: string,
    nature?: string,
    manager?: { external_id: string, name: string, firstname?: string }
  ) {
    this.id = id
    this.creation_date = creation_date
    this.validation_data = validation_date
    this.signature_date = signature_date
    this.status = status
    this.client = client
    this.detail = detail
    this.advisor = advisor
    this.present = present
    this.subscriptionGlobalAmount = subscriptionGlobalAmount
    this.integrate_state = integrate_state
    this.formId = formId
    this.detention_mode = detention_mode
    this.dismemberment_type = dismemberment_type
    this.dismemberment_scope = dismemberment_scope
    this.pairing = pairing
    this.plateforme_state = plateforme_state
    this.nb_parts = nb_parts
    this.is_physical = is_physical
    this.product_name = product_name
    this.nature = nature
    this.manager = manager
  }
}

export {
  Folder,
  FolderDetail
}
